import { ViewFactory } from 'wdc-cube-react'

import { ChangePasswordScope, MainScope } from '../Main.scopes'
import { MainView } from './Main.view'

import { BodyScope } from '../Main.scopes'
import { BodyView } from './body.view'

import { SignInScope } from '../Main.scopes'
import { SingInView } from './sign-in.view'

import { ResetPasswordScope } from '../Main.scopes'
import { ChangePasswordView } from './change-password.view'
import { ResetPasswordView } from './reset-password.view'

export { MainView } from './Main.view'

export function registerViews(rv = ViewFactory.register) {
    rv(MainScope, MainView)
    rv(BodyScope, BodyView)
    rv(SignInScope, SingInView)
    rv(ResetPasswordScope, ResetPasswordView)
    rv(ChangePasswordScope, ChangePasswordView)
}
